module.exports = require("@cdm-logger/client");